import { GlLink, GlPopover, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { helpPagePath } from '~/helpers/help_page_helper';
export default {
    name: 'WorkplanAvailabilityPopover',
    components: {
        GlLink,
        GlPopover,
        GlSprintf
    },
    props: {
        target: {
            type: Function,
            required: true
        },
        reason: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            containerId: uniqueId('workplan-availability-')
        };
    },
    workplanHelpPath: helpPagePath('user/work_items/workplan', {
        anchor: 'set-up-workplan-generation'
    })
};
